export const usuarioModel = {
  usuario: function () {
    return {
      id: '',
      ds_email: '',
      password: '',
      tp_usuario: '',
      pessoa_id: ''
    }
  },
}


// WEBPACK FOOTER //
// ./src/views/Usuario/_model/usuario.js